module.exports = __webpack_public_path__ + "static/02-8480d29fee29bbf1cef3d098f79d9101.jpg";